// AuthContext.js
import React, { createContext, useState, useContext, useEffect, useCallback } from "react";
import { API_VERSION, SERVER_URL } from "../consts";
import logger from "./Logger";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    checkAuth && checkAuth();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    logger.info("Authenticated: ", authenticated);
  }, [authenticated]);

  useEffect(() => {
    setInterval(() => {
      logger.info("Waking up, checking if user is authenticated");
      checkAuth && checkAuth();
    }, 1000 * 60 * 5);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkAuth = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      logger.info("Checking if user is authenticated");
      const response = await fetch(`${SERVER_URL}${API_VERSION}/users/auth-check`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        // Include any necessary credentials, like cookies
        credentials: "include",
      });

      if (response.ok) {
        logger.info("User is authenticated");
        if (!authenticated) {
          setAuthenticated(true);
        }
      } else {
        logger.info("User is not authenticated", console.trace());
        if (authenticated) {
          setAuthenticated(false);
        }
      }
    } catch (err) {
      logger.error("Error checking if user is authenticated - ", err);
      setError(err.message);
      setAuthenticated(false);
    } finally {
      setLoading(false);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const navigationEntries = performance.getEntriesByType("navigation");
    const isReloaded = navigationEntries.some((entry) => entry.type === "reload");
    if (isReloaded) {
      checkAuth();
    }
  }, [checkAuth]);

  const value = { authenticated, checkAuth, loading, error, setAuthenticated };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
